/*
 * @Author: Lucas Fridez
 * @Date: 2019-09-06 07:58:39
 * @LastEditors: Lucas Fridez
 * @LastEditTime: 2019-09-06 11:30:45
 * @Description: file content
 */
/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * @client Inelectro
 * @project webapp-scan
 * @file src\app\framework\Product.ts
 * @copyright 2018 Artionet Web Agency
 */

 import { NetworkManager } from "./../managers/NetworkManager";

/**
 * @description Class Product. Use with the API to recuperate the products
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class Product
 */
export class Product {
    private _id: string;
    private _name: string;
    private _code: string;
    private _borrowed: boolean;
    private _category: string;
    private _description: string;
    private _damages: string[];
    private _employeName: string;
    private _employeSurname: string;
    private _price: number;
    private _phone: string;
    private _warehouse: string;
    private _hasimage: boolean;

    /**
     * Creates an instance of Product.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {*} json
     * @memberof Product
     */
    constructor(json: any) {
        this._id = json.id;
        this._name = json.name;
        this._code = json.qrcode;
        this._borrowed = json.borrowed;
        this._category = json.category;
        this._description = json.description;
        this._damages = json.damages;
        this._employeName = json.employe_name;
        this._employeSurname = json.employe_surname;
        this._price = json.price;
        this._phone = json.phone;
        this._warehouse = json.warehouse;
        this._hasimage = json.hasimage;
    }

    /**
     * @description Get the id of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get id(): string {
        return this._id;
    }

    /**
     * @description Get the name of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get name(): string {
        return this._name;
    }

    /**
     * @description Get the qrcode of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get qrcode(): string {
        return this._code;
    }

    /**
     * @description Get the state (if borrowed) of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {boolean}
     * @memberof Product
     */
    public get borrowed(): boolean {
        return this._borrowed;
    }

    /**
     * @description Get the category of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get category(): string {
        return this._category;
    }

    /**
     * @description Get the description of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get description(): string {
        return this._description;
    }

    /**
     * @description Get the name of the Employe that possesses the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get employeName(): string {
        return this._employeName;
    }

    /**
     * @description Get the surname of the Employe that possesses the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get employeSurname(): string {
        return this._employeSurname;
    }

    /**
     * @description Get the price of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {number}
     * @memberof Product
     */
    public get price(): number {
        return this._price;
    }

    /**
     * @description Get the Warehouse where is located the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get warehouse(): string {
        return this._warehouse;
    }

    /**
     * @description Get the Owner (User) of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get owner(): string {
        return this.employeName + " " + this.employeSurname;
    }

    /**
     * @description Return the user's phone number
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get phone(): string {
        return this._phone;
    }

    /**
     * @description Get the image of the Product
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @type {string}
     * @memberof Product
     */
    public get image(): string {
        return this._hasimage ? `${NetworkManager.IMG_URL}/${this.id}/main-image.png` : "";
    }

    public get damages(): any {
        return this._damages;
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/Product.ts